import { combineReducers } from "@reduxjs/toolkit";

import { defaultImagesListingReducer } from "./DefaultImageSlice";

export const defaultImagesReducer = combineReducers({
  defaultImagesListing: defaultImagesListingReducer,
});
